export default __webpack_public_path__ + "static/mobile-view-8753d3b0cb697ccd16585bc55a7c6ff3.webp";